<h2 class="title">{{ offer?.title }}</h2>
<div>   @if (false && offer?.created) {
            <span>Dodano: {{ $safeNavigationMigration(offer?.created) | date:'yyyy-MM-dd' }}</span>
          }</div>
@if (offer) {
  <div class="offer-details-card">
    <div class="offer-details-top">
      <div class="offer-details-left">
        
        @if (offer?.file) {
          <div class="offer-image-box">
            <app-offer-image [offer]="offer" imageClass="offer-image"></app-offer-image>
          </div>
        }

      </div>
      <div class="offer-details-right">
        <div class="offer-details-date">
         
          <h2>{{ partner?.name }} </h2>
          <div><button class="custom-button" (click)="goToPartnerDetails(partner.id, partner.name)">Przejdź do Partnera</button></div>
           @if (false && offer.valid) {
            <span>Ważna do: {{ offer.valid | date:'yyyy-MM-dd' }} ({{ leftTime(offer.valid) }})</span>
          }
        </div>
        @if (false) {
        <div class="offer-details-partner">
          
          @if (partner) {
            <app-partnerspartner-view (click)="goToPartnerDetails(partner.id, partner.name)"
              class="partner-item" [partner]="partner">
            </app-partnerspartner-view>
          }

     
        </div>
        }
        
        <div class="offer-details-content" [innerHTML]="offer.content"></div>
      </div>
    </div>
    
  </div>
}